/* eslint-disable no-else-return */
import styled, { css } from "styled-components";
import NavItemLink from "components/base/NavItemLink";
import Text from "components/typography/Text";
import Tooltip from "components/layout/Tooltip";
import Icon from "components/global/Icon";
import List from "./List";
import Item from "./Item";

// ** SVG Static Imports
import { ReactComponent as SolidUserCircle } from "resources/icons/solid/user-circle.svg";
import { ReactComponent as SolidTrophy } from "resources/icons/solid/trophy.svg";
import { ReactComponent as SolidUserFriends } from "resources/icons/solid/user-friends.svg";
import { ReactComponent as SolidAlignLeft } from "resources/icons/solid/align-left.svg";
import { ReactComponent as SolidVideo } from "resources/icons/solid/video.svg";
import { ReactComponent as SolidUsers } from "resources/icons/solid/users.svg";
import { ReactComponent as SolidGlassCheers } from "resources/icons/solid/glass-cheers.svg";
import { ReactComponent as SolidBan } from "resources/icons/solid/ban.svg";
import { ReactComponent as SolidExclamationCircle } from "resources/icons/solid/exclamation-circle.svg";
import { ReactComponent as SolidLocationArrow } from "resources/icons/solid/location-arrow-solid.svg";
const svgIconsList = {
	["user-circle"]: SolidUserCircle,
	["trophy"]: SolidTrophy,
	["user-friends"]: SolidUserFriends,
	["align-left"]: SolidAlignLeft,
	["video"]: SolidVideo,
	["users"]: SolidUsers,
	["glass-cheers"]: SolidGlassCheers,
	["ban"]: SolidBan,
	["exclamation-circle"]: SolidExclamationCircle,
	["location-arrow-solid"]: SolidLocationArrow,
};

const MenuListItemIcon = styled(Icon)`
	font-size: 1.2rem;
	min-width: 2rem;
	display: inline-block;

	${({ presentationTemplate }) =>
		presentationTemplate &&
		css`
			font-size: 0.85em;
			min-width: 1.35rem;
		`}
`;

export default ({
	items,
	onMenuItemClick,
	dropdownContainer,
	userpanelMenu,
	userpanelSideMenu,
	presentationTemplate,
	customPadding,
}) => {
	return (
		<List
			userpanelMenu={userpanelMenu}
			userpanelSideMenu={userpanelSideMenu}
			presentationTemplate={presentationTemplate}
		>
			{items.map((item, i) => {
				const key = item.key || `menuitem-${i}`;
				if (item.onClick) {
					if (item.tooltip && item.disabled) {
						return (
							<Item
								onClick={(event) => {
									if (onMenuItemClick) {
										onMenuItemClick();
									}
									if (item.onClick) {
										setTimeout(() => {
											item.onClick(event);
										}, 1);
									}
								}}
								isActive={item.isActive}
								disabled={item.disabled}
								key={key}
								userpanelMenu={userpanelMenu}
								presentationTemplate={presentationTemplate}
							>
								<Item.Content
									flexWrap={item.wrap}
									$customPadding={customPadding}
								>
									<Tooltip
										text={item.tooltip}
										toggleStyle={{ width: "100%" }}
										palcement={{ triggerOffset: 10 }}
									>
										{item.icon && (
											<MenuListItemIcon
												presentationTemplate={
													presentationTemplate
												}
												svgIconComponent={
													svgIconsList[item.icon]
												}
												icon={item.icon}
												isActive={item.isActive}
											/>
										)}
										{item.content &&
										typeof item.content === "function"
											? item.content({
													item,
													key,
													onMenuItemClick,
													dropdownContainer,
											  })
											: item.content}

										{item.append &&
										typeof item.append === "function"
											? item.append({ item })
											: null}
									</Tooltip>
								</Item.Content>
							</Item>
						);
					}
					return (
						<Item
							onClick={(event) => {
								if (onMenuItemClick) {
									onMenuItemClick();
								}
								if (item.onClick) {
									setTimeout(() => {
										item.onClick(event);
									}, 1);
								}
							}}
							key={key}
							isActive={item.isActive}
							disabled={item.disabled}
							userpanelMenu={userpanelMenu}
							presentationTemplate={presentationTemplate}
						>
							<Item.Content
								flexWrap={item.wrap}
								$customPadding={customPadding}
							>
								{item.icon && (
									<MenuListItemIcon
										presentationTemplate={
											presentationTemplate
										}
										svgIconComponent={
											svgIconsList[item.icon]
										}
										icon={item.icon}
										isActive={item.isActive}
									/>
								)}
								{item.content &&
								typeof item.content === "function"
									? item.content({
											item,
											key,
											onMenuItemClick,
											dropdownContainer,
									  })
									: item.content}
							</Item.Content>
							{/* {item.append && typeof item.append === "function" ? item.append({ item }) : null} */}
						</Item>
					);
				}
				if (item.link) {
					return (
						<NavItemLink
							container={Item}
							{...item.link}
							userpanelMenu={userpanelMenu}
							onClick={(event) => {
								if (
									typeof item.beforeClick === "function" &&
									!item.beforeClick(event)
								) {
									return event.preventDefault();
								}

								if (onMenuItemClick) {
									onMenuItemClick();
								}
								if (item.onClick) {
									setTimeout(() => {
										item.onClick(event);
									}, 1);
								}
							}}
							key={key}
						>
							<Item.Content
								flexWrap={item.wrap}
								$customPadding={customPadding}
							>
								{item.icon && (
									<MenuListItemIcon
										presentationTemplate={
											presentationTemplate
										}
										svgIconComponent={
											svgIconsList[item.icon]
										}
										icon={item.icon}
										isActive={item.isActive}
									/>
								)}
								{item.content &&
								typeof item.content === "function" ? (
									item.content({
										item,
										key,
										onMenuItemClick,
									})
								) : (
									<Text color={item.color || "black"}>
										{item.content}
									</Text>
								)}
								{item.append &&
								typeof item.append === "function" ? (
									<>
										{item.append({
											item,
											key,
											onMenuItemClick,
										})}
									</>
								) : null}
							</Item.Content>
						</NavItemLink>
					);
				}
				if (item.content) {
					if (typeof item.content === "function") {
						return item.content({
							item,
							key,
							onMenuItemClick,
							dropdownContainer,
						});
					}
					return (
						<Item
							key={key}
							userpanelMenu={userpanelMenu}
							presentationTemplate={presentationTemplate}
						>
							<Item.Content
								flexWrap={item.wrap}
								$customPadding={customPadding}
							>
								{item.icon && (
									<MenuListItemIcon
										presentationTemplate={
											presentationTemplate
										}
										svgIconComponent={
											svgIconsList[item.icon]
										}
										icon={item.icon}
										isActive={item.isActive}
									/>
								)}
								{item.content}
							</Item.Content>
							{/* {item.append && typeof item.append === "function" ? item.append({ item }) : null} */}
						</Item>
					);
				}
				return null;
			})}
		</List>
	);
};
